const LETTERS = ["a", "b", "c", "d"];

export function OptionsSection({ section, onSendMessage }) {
  return (
    <div data-testid="typed-section-options" className="flex flex-col gap-2 my-3">
      {section.options.map((opt, i) => (
        <button
          key={i}
          data-testid={`typed-section-option-button-${i}`}
          onClick={() => onSendMessage(opt.send_message)}
          className="text-left px-3 py-2 rounded-lg border border-border hover:border-emerald-500/50 hover:bg-emerald-500/5 transition-colors text-sm"
        >
          <span className="font-mono text-emerald-500 mr-2">{LETTERS[i] || i}) </span>
          {opt.label}
        </button>
      ))}
    </div>
  );
}
